<template>
  <div id="recruitPartners-construction">
    <div class="layout">
      <!-- 导航栏 -->
      <navMenu positionType="fixed" topValue="0"></navMenu>
      <div class="bgwhite">
        <div class="comingSoon">
          <img src="@/assets/images/public/comingSoon.png" />
          <p>敬请期待...</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navMenu from "@/components/navMenu";
export default {
  components: {
    navMenu
  }
};
</script>
<style lang="scss" scoped>
#recruitPartners-construction {
  .layout {
    margin-bottom: 24px;
    .comingSoon {
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      p {
        font-size: 24px;
        margin-top: 38px;
      }
    }
  }
}
</style>